import request from '@/utils/request2'

// 列表(主数据列表)
export function loadSurveyProductSettingListDataApi (data) {
  return request({
    url: 'tms-web/surveyProductSetting/listByPage',
    method: 'post',
    data
  })
}

// 导出
export function exportSurveyProductSettingListDataApi (data) {
  return request({
    url: 'tms-web/surveyProductSetting/exportByPage',
    method: 'post',
    data
  })
}

// 保存
export function saveSurveyProductSettingApi (data) {
  return request({
    url: 'tms-web/surveyProductSetting/save',
    method: 'post',
    data
  })
}

// 修改状态
export function updateSurveyProductSettingStatusApi (data) {
  return request({
    url: 'tms-web/surveyProductSetting/updateStatus',
    method: 'post',
    data
  })
}

// 按市场批量设置
export function batchUpdateSurveyProductSettingApi (data) {
  return request({
    url: 'tms-web/surveyProductSetting/settingByCity',
    method: 'post',
    data
  })
}

// 查看
export function viewSurveyProductSettingApi (data) {
  return request({
    url: 'tms-web/surveyProductSetting/view',
    method: 'post',
    data
  })
}

// 列表
export function listSurveyProductSettingApi (data) {
  return request({
    url: 'tms-web/surveyProductSetting/list',
    method: 'post',
    data
  })
}